import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_e3b3c70d-c72e-49dc-b41a-da6affdc6e46/artifacts/4w4rfom9_IMG_0777.PNG";

/**
 * Visitex logo that doubles as a "go home" link.
 * Home destination is chosen from the current user's role; falls back to /login
 * when there's no logged-in user (e.g. on the LoginPage itself).
 */
export function LogoHome({ className = 'h-10 w-auto', alt = 'Visitex — go to home' }) {
  const { user } = useAuth();
  const role = user?.role;
  const home =
    role === 'organisation' ? '/admin' :
    role === 'supervisor' ? '/supervisor' :
    role === 'participant' ? '/participant' :
    role === 'worker' ? '/dashboard' :
    '/login';

  return (
    <Link
      to={home}
      aria-label="Go to home dashboard"
      data-testid="logo-home-link"
      className="inline-flex items-center hover:opacity-90 transition-opacity"
    >
      <img src={LOGO_URL} alt={alt} className={className} />
    </Link>
  );
}

export default LogoHome;
